import env from "../../config/env"

export const formatCdnPath = (icon: string): string => `${env.APP_BLOB_STORAGE_PATH.replace(/\/$/, "")}${icon}`

export const formatCdnPathWithVariant = (icon: string, realm: string, variant?: string, version?: string): string => {
    const assetName = icon.split("/").pop() as string
    const versionPath = version ? `/${version}` : ""
    const iconPath = variant
        ? `/icons/header/${realm}${versionPath}/${variant}/${assetName}`
        : `/icons/header/${realm}${versionPath}/${assetName}`
    return formatCdnPath(iconPath)
}

export const getMeganavIconPath = (icon: string, realm?: string | undefined): string => {
    if (realm) {
        return formatCdnPath(`/icons/meganav/${realm}/${icon}`)
    }
    return formatCdnPath(`/icons/shared/${icon}`)
}

export const getMeganavIconPathWithVariant = (icon: string, realm: string, variant: string | undefined): string => {
    if (realm && variant) {
        return formatCdnPath(`/icons/meganav/${realm}/${variant}/${icon}`)
    }
    return formatCdnPath(`/icons/shared/${icon}`)
}
